export default __webpack_public_path__ + "static/media/050_brake.first.e93d8310.webp";